import Layout from "../../layouts/layout";
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useEffect, useState } from "react";
import { DateTimePicker } from "react-advance-jalaali-datepicker"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout";
import { useRequestProcessor } from "../../api/requestProcessor";
import { useNavigate } from "react-router-dom";
import { storeSingleNotifications } from "../../api/notifications";
import { getAllTemplates } from "../../api/kavenegar";
import { getAllUsers, getAllUsersWithoutPaginate } from "../../api/users";
import { getAllWorkshops, getAllWorkshopsWithoutPaginate } from "../../api/workshops";


import Select from "react-select";
import makeAnimated from 'react-select/animated';
import { getAllCoursesWithoutPaginate } from "../../api/course";




const CreateNotification = () => {

    const [selectedUsers, setSelectedUsers] = useState([])
    const [selectedWorkshops, setSelectedWorkshops] = useState(null)
    const [selectedCourses, setSelectedCourses] = useState(null)

    const [token, setToken] = useState("")
    const [token2, setToken2] = useState("")
    const [token3, setToken3] = useState("")
    const [isToken, setIsToken] = useState(false)
    const [isToken2, setIsToken2] = useState(false)
    const [isToken3, setIsToken3] = useState(false)


    
    const [formated, setFormated] = useState("")
    
    const [isSms, setIsSms] = useState(false)
    const [isLocal, setIsLocal] = useState(false)

    const [messageID, setMessageID] = useState()
    const [message, setMessage] = useState("")

    const [date, setDate] = useState()

    const { Query, Mutate } = useRequestProcessor();
    const navigate = useNavigate()


    const { data: templateData, isLoading, isError } = Query(
        ['getAllTemplates',],
        () => getAllTemplates(),
    );
    const { data: workshopData, } = Query(
        ['getAllWorkshopsWithoutPaginate'],
        () => getAllWorkshopsWithoutPaginate(),
    );
    const { data: courseData, } = Query(
        ['getAllCoursesWithoutPaginate'],
        () => getAllCoursesWithoutPaginate(),
    );
    const { data: usersData, } = Query(
        ['getAllUsersWithoutPaginate'],
        () => getAllUsersWithoutPaginate(),
    );


    const { mutate } = Mutate(
        "storeSingleNotification",
        storeSingleNotifications,
        {
            onSuccess: (data) => {
                toast.success(data.message)
                toast.info("تا چند ثانیه دیگر به صفحه اصلی منتقل میشوید", {
                    autoClose: 2500,
                    pauseOnHover: false
                })
                setTimeout(() => { navigate("/admin/notifications") }, 3000)
            },
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    )

    useEffect(() => {
        setIsToken(message.includes("%token"))
        setIsToken2(message.includes("%token2"))
        setIsToken3(message.includes("%token3"))
    }, [message])


    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();


    function change(unix, formatted) {
        setDate(unix);
        setFormated(formatted);
    }

    async function onHookFormhandler(data) {
        data = {
            ...data,
            send_at: date,
            drivers: [isLocal ? "local" : null, isSms ? "kavenegar" : null],
            message: message,
            kavenegar_data: messageID ? {
                template_id:messageID,
                token: isToken ? token : null,
                token2: isToken2 ? token2 : null,
                token3: isToken3 ? token3 : null,
            } : null,
            users: selectedUsers.length ? selectedUsers.map(el => (el.value)) : null,
            workshop_id: selectedWorkshops.length ? selectedWorkshops[0].value : null,
            course_id: selectedCourses.length ? selectedCourses[0].value : null
        };
        // console.log(data);
        mutate(data)
    }

    const animatedComponents = makeAnimated();
    function handleOnChange(data) {
        setSelectedUsers(data)
        setSelectedCourses([])
        setSelectedWorkshops([])
    }
    function handleOnChangeWorkshop(data) {
        setSelectedWorkshops(data)
        setSelectedUsers([])
        setSelectedCourses([])
    }
    function handleOnChangeCourses(data) {
        setSelectedCourses(data)
        setSelectedUsers([])
        setSelectedWorkshops([])
    }
    return (
        <Layout title="ایجاد قالب">
            <MainPageLayout title={"ایجاد اعلامیه جدید"} >
                <form onSubmit={handleSubmit((data) => onHookFormhandler(data))} className='flex transition-all flex-col'>
                    {/* <h1 className="text-[1.5rem]">ایجاد کاربر جدید</h1> */}
                    <div className="flex wsm:flex-col">
                        <div className='flex-col my-4 !w-full'>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.title && "text-red-500"}`}>عنوان :</p>
                                <input type="text" {...register("title", { required: true })} className='form-input !w-full' placeholder='عنوان' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1`}>نوع پیغام :</p>
                                <div className="">
                                    <div className={` cursor-pointer border my-2 p-3 rounded-lg ${isSms && "border-green-500"}`}
                                        onClick={() => { setMessage(""); setIsSms(prev => !prev) }}>
                                        {isSms && <span className="text-green-500 ml-2">✓</span>}
                                        پیغام (kavenegar)
                                    </div>
                                    <div className={` cursor-pointer border my-2 p-3 rounded-lg ${isLocal && "border-green-500"}`}
                                        onClick={() => { setIsLocal(prev => !prev) }}>
                                        {isLocal && <span className="text-green-500 ml-2">✓</span>}
                                        داخلی
                                    </div>

                                </div>
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.title && "text-red-500"}`}>تاریخ ارسال :</p>
                                <DateTimePicker format="jYYYY/jMM/jDD HH:mm" onChange={change} containerClass="form-input date-picker-bg wsm:!w-fit" cancelOnBackgroundClick customClass="cs" placeholder="انتخاب تاریخ و زمان" className='form-input w-full' />
                            </div>

                        </div>
                        <div className="flex-col my-4 !w-full mr-2">
                            {isSms &&
                                <div className="flex flex-col border-4">
                                    <h1 className="flex justify-center py-3 font-bold items-center">
                                        قالب اعلامیه را انتخاب کنید.
                                        <span className="text-xs text-gray-500">
                                            (برای تغییر یا ایجاد به کاوه نگار مراجعه کنید)
                                        </span>
                                    </h1>
                                    <table className="table-auto" >
                                        <thead className="!py-2">
                                            <tr className="flex border-b border-black">
                                                <th className="p-4 w-1/3">#</th>
                                                <th className="p-4 w-1/3">عنوان</th>
                                                <th className="p-4 w-1/3">پیغام</th>
                                            </tr>
                                        </thead>
                                        {
                                            <tbody className="flex flex-col items-center justify-between overflow-y-auto !w-full max-h-[200px]" >
                                                {
                                                    templateData?.data.map(el => (
                                                        <tr onClick={() => { setMessage(el.message);setMessageID(el.id) }} key={el.id} className="flex cursor-pointer items-center text-[#575757] border-b [&>*]:w-1/3 w-full border-[#d5d5d5] hover:bg-[#fafafa]"  >
                                                            <td className="text-center p-4" >{el.id}</td>
                                                            <td className="text-center p-4" >
                                                                <p>{el.name}</p>
                                                            </td>
                                                            <td className="text-center p-5 text-sm" > {el.message}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        }
                                    </table>
                                </div>}
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 `}>پیغام :</p>
                                <textarea type="text" rows={5} disabled={isSms} value={message} onChange={(e) => setMessage(e.target.value)} className={`form-input !w-full`} placeholder='پیغام خود را  به همراه توکن وارد کنید' />
                            </div>
                            {isSms && <div className="flex flex-col">
                                <div className="flex my-2 rounded-lg border items-center  text-center">
                                    <p className="bg-gray-500 flex-col justify-center  rounded-r-lg px-4 h-[45px] text-white !w-1/2 ">Token % :</p>
                                    <input type="text" disabled={!isToken} value={token} onChange={e => setToken(e.target.value)}
                                        className={`form-input !w-full !rounded-r-none ${!isToken && "cursor-not-allowed"}`} />
                                </div>

                                <div className=" flex my-2 rounded-lg border items-center  text-center">
                                    <p className="bg-gray-500 flex-col justify-center  rounded-r-lg px-4 h-[45px] text-white !w-1/2 ">Token 2 % :</p>
                                    <input type="text" disabled={!isToken2} value={token2} onChange={e => setToken2(e.target.value)}
                                        className={`form-input !w-full !rounded-r-none ${!isToken2 && "cursor-not-allowed"}`} />
                                </div>
                                <div className="flex my-2 rounded-lg border items-center  text-center">
                                    <p className="bg-gray-500 flex-col justify-center  rounded-r-lg px-4 h-[45px] text-white !w-1/2 ">Token 3 % :</p>
                                    <input type="text" disabled={!isToken3} value={token3} onChange={e => setToken3(e.target.value)}
                                        className={`form-input !w-full !rounded-r-none ${!isToken3 && "cursor-not-allowed"}`} />
                                </div>
                            </div>}
                        </div>
                    </div>
                    <div className="flex">
                        <div className="w-full">

                            <div className='flex flex-col '>
                                <p className='pr-3 pb-1'>انتخاب کاربران :</p>
                                <Select components={animatedComponents} placeholder="انتخاب کنید..."
                                    onChange={handleOnChange} closeMenuOnSelect={false} value={selectedUsers}
                                    isMulti options={usersData?.data?.map(el => ({ label: el.name + " " + el.lastname, value: el.id }))}
                                />
                            </div>
                        </div>

                        <div className="w-full pr-4">
                            <div className='flex flex-col mr-3'>
                                <p className='pr-3 pb-1'>انتخاب ورک شاپ :</p>
                                <Select components={animatedComponents} placeholder="انتخاب کنید..." styles={{ zIndex: "-1" }}
                                    onChange={handleOnChangeWorkshop} closeMenuOnSelect={false} value={selectedWorkshops} isMulti isOptionDisabled={() => selectedWorkshops?.length }
                                    options={workshopData?.data?.map(el => ({ label: el.title, value: el.id }))}
                                />
                            </div>
                            <div className='flex flex-col mt-4 mr-3'>
                                <p className='pr-3 pb-1'>انتخاب دوره :</p>
                                <Select components={animatedComponents} placeholder="انتخاب کنید..." styles={{ zIndex: "-1" }}
                                    onChange={handleOnChangeCourses} closeMenuOnSelect={false} value={selectedCourses} isMulti isOptionDisabled={() => selectedCourses?.length }
                                    options={courseData?.data?.map(el => ({ label: el.title, value: el.id }))}
                                />
                            </div>

                        </div>

                    </div>
                    <div id='form-add-button--container'>
                        <button type="submit" id='form-add-button'>ثبت</button>
                    </div>
                </form>
            </MainPageLayout>
        </Layout>
    )
}

export default CreateNotification